(function() {
  define('app/extensions/ajaxFormatAdder',['jquery'], function($) {
    return $(document).ajaxSend(function(e, xhr, options) {
      var params, url;
      url = options.url.split("?");
      if (url[1]) {
        params = "?" + url[1];
      }
      url = url[0];
      if (url.indexOf(".json") > -1) {
        return;
      }
      if (url.indexOf(".m3u") > -1) {
        return;
      }
      if (url.substr(-1) === "/") {
        url = url.substr(0, url.length - 1);
      }
      url += ".json";
      options.url = url + (params || "");
    });
  });

}).call(this);

//# sourceMappingURL=ajaxFormatAdder.js.map
;
